import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import './button.scss'

const StyledLink = styled(Link)`
  width: 200px;
  padding: 10px;
  font-size: 1.2rem;
  background-color: #90d1a8;
  // color: white;
  color: #333;
  border-color: #333;
  // border: 1px solid #333;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #78b08f;
`

const StyledDiv = styled.button`
  width: 200px;
  padding: 10px;
  font-size: 1.2rem;
  background-color: #90d1a8;
  // color: white;
  color: #333;
  border-color: #333;
  // border: 1px solid #333;
  text-decoration: none;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #78b08f;
  border: none;
  outline: none;
  width: 220px;
`

export class Button extends React.PureComponent {
    render () {
        const { text, to, onClick, className, ...props } = this.props
        const Element = to ? StyledLink : StyledDiv
        const classes = `Button ${className || ''}`
        return (
            <Element className={classes} to={to} onClick={onClick} {...props}>
                <span>{text}</span>
            </Element>
        )
    }
}

export default Button
